import { gql } from '@apollo/client'

// Mobile cannot safely hold an OpenAI API key. The backend owns that credential
// and returns a short-lived Realtime client secret that is only useful for the
// current WebRTC session setup.
export const CREATE_NORA_REALTIME_CLIENT_SECRET = gql`
  mutation createNoraRealtimeClientSecret {
    createNoraRealtimeClientSecret {
      noraSpeech {
        value
        expiresAt
      }
      userTranscription {
        value
        expiresAt
      }
    }
  }
`
